<template>
    <popper-modal ref="dropdown">
        <template #trigger="{ isOpen }">
            <editor-button :active="isOpen" ref="button">
                <svg-icon type="mood" :class="iconSize"></svg-icon>
            </editor-button>
        </template>
        <template #content>
            <keep-alive>
                <emoji-picker ref="emojiPicker" @select="handleSelect"></emoji-picker>
            </keep-alive>
        </template>
    </popper-modal>
</template>

<script>
import EmojiPicker from './EmojiPicker.vue';
import SvgIcon from './SvgIcon.vue';
import EditorButton from './EditorButton.vue';
import PopperModal from '../PopperModal.vue';

export default {
    components: {
        'popper-modal': PopperModal,
        'emoji-picker': EmojiPicker,
        'svg-icon': SvgIcon,
        'editor-button': EditorButton,
    },
    props: {
        small: Boolean,
    },
    computed: {
        iconSize() {
            return this.small ? 'w-18 h-18' : 'w-24 h-24';
        }
    },
    methods: {
        handleSelect (emoji) {
            this.$emit('select', emoji);
            this.$refs.dropdown.close();
        }
    }
}
</script>
